import { useSegmentReset } from '~/composables/Segment/useSegmentReset'
import { useCleanCache } from '~/composables/useCleanCache'
import { useCustomerIO } from '~/composables/useCustomerIO'
import { useGrowthBook } from '~/composables/useGrowthBook'
import { useLanguage } from '~/composables/useLanguage'

import { useMiscDraftStore } from '~/stores/miscDraft'
import { useUserStore } from '~/stores/user'

export function useLogout() {
  const { $pinia } = useNuxtApp()
  const { updateLanguageToCurrentState } = useLanguage()
  const localePath = useLocalePath()
  const { cleanCacheAll } = useCleanCache()
  const segmentReset = useSegmentReset()
  const { customerIOReset } = useCustomerIO()
  const { resetGrowthBookIdentityAttributes } = useGrowthBook()

  const { IS_BAND } = storeToRefs(useUserStore($pinia))
  const { LOGOUT } = useUserStore($pinia)

  const { SET_LOGIN_OUT } = useMiscDraftStore($pinia)

  async function logout(
    { shouldRedirect }: { shouldRedirect: boolean } = { shouldRedirect: true },
  ) {
    if (IS_BAND.value) SET_LOGIN_OUT()

    await LOGOUT()
    cleanCacheAll()
    segmentReset()
    customerIOReset()
    resetGrowthBookIdentityAttributes()
    await updateLanguageToCurrentState()
    if (shouldRedirect)
      reloadNuxtApp({ path: localePath('/'), ttl: 1000, force: true })
  }

  return { logout }
}
